<template>
  <el-checkbox
    :value="checked"
    @change="handleChange"
  >{{ value.node_name }}</el-checkbox>
</template>

<script>
export default {
  name: 'CheckBoxItem',
  props: {
    // 每一项数据
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 父级每一项数据
    pValue: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 所有选中的id集合
    checkedIds: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 子项
    children: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    checked() {
      return this.checkedIds.includes(this.value.node_id)
    },
    ids() {
      return this.children.map(item => item.node_id)
    },
    curCheckedIds() {
      return this.checkedIds.filter(item => this.ids.includes(item))
    }
  },
  methods: {
    handleChange(checked) {
      if (checked) {
        this.$emit('change', Array.from(new Set([...this.checkedIds, this.value.node_id, this.pValue.node_id])))
      } else {
        // TODO：如果是三级联动开启注释
        // if (this.curCheckedIds.length > 1) {
        //   const checkedIds = this.checkedIds.filter(item => this.value.node_id !== item)
        //   this.$emit('change', checkedIds)
        // } else {
        //   const checkedIds = this.checkedIds.filter(item => this.value.node_id !== item).filter(list => this.pValue.node_id !== list)
        //   this.$emit('change', checkedIds)
        // }
        const checkedIds = this.checkedIds.filter(item => this.value.node_id !== item)
        this.$emit('change', checkedIds)
      }
    }
  }
}
</script>

<style>

</style>
